import { useMemo } from 'react';
import { CSVLink } from 'react-csv';
import { dateFormat, timeFormat } from 'utils/helpers';

interface CSVProps {
    data: object[];
    headers?: object[];
    fileName?: string;
    children?: React.ReactNode;
    disabled?: boolean;
}

const DownloadCSV = ({ data, headers, fileName = 'Old_Glory', children, disabled }: CSVProps) => {
    const props: any = { filename: fileName };
    if (headers) {
        props.headers = headers;
    }

    const normalizeData = useMemo(() => {
        const _data = [...(data || [])];
        return _data.map((item: any) => {
            let _item = { ...item };
            Object.keys(item).forEach((key: string) => {
                if (key.toLowerCase().includes('date')) {
                    _item = {
                        ...item,
                        Date: dateFormat(item[key]),
                    };
                } else if (key.toLowerCase().includes('time')) {
                    _item = {
                        ...item,
                        Time: timeFormat(item[key], 'hh:mm A'),
                    };
                }
            });
            return _item;
        });
    }, [data]);
    return (
        <CSVLink data={normalizeData} className="MuiButton-root" onClick={() => !disabled} {...props}>
            {children || 'Export to csv'}
        </CSVLink>
    );
};

export default DownloadCSV;
